import type { FC, ReactNode } from 'react';
import styles from './Container.module.css';

interface ContainerProps {
  children: ReactNode;
  size?: 'narrow' | 'default' | 'wide';
}

export const Container: FC<ContainerProps> = ({ children, size = 'default' }) => {
  return <div className={[styles.root, styles[size]].join(' ')}>{children}</div>;
};

Container.displayName = 'Container';
